module.exports = __webpack_public_path__ + "static/fourpcpinkfloral1-44deb0d6e672da351d8254db2d2a5cd3.jpeg";